/*
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: router
 * @Description: 路由
 * @FilePath: \web_manage_globalf:\work\web\app-tikfriend_web\src\router\index.js
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-27 16:07:25
 * @LastEditors: syl
 * @LastEditTime: 2022-05-10 13:58:49
 * @example: 调用示例
 */
import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/pages/HomePage'
import Home from '@/pages/content/Home'
import Team from '@/pages/content/Team'
import Download from '@/pages/content/Download'
import JoinUs from '@/pages/content/JoinUs'
import NotFind from '@/pages/content/NotFind'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/team',
      component: HomePage,
      children: [
        // {
        //   path: '/home',
        //   name: 'home',
        //   component: Home
        // },
        {
          path: '/team',
          name: 'team',
          component: Team
        },
        {
          path: '/chat',
          name: 'chat',
          component: Download
        },
        {
          path: '/work',
          name: 'work',
          component: Download
        },
        {
          path: '/monitor',
          name: 'monitor',
          component: Download
        },
        {
          path: '/goudrive',
          name: 'goudrive',
          component: Download
        },
        {
          path: '/joinus',
          name: 'joinus',
          component: JoinUs
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: NotFind
    }
  ]
})
